<template>
  <div class="auth" v-show="!authenticated">
    <div class="loader"></div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      authenticated: false
    }
  },
  methods: {
    getToken () {
      axios.post(`${process.env.VUE_APP_API_URL}/auth/register`)
        .then(response => {
          this.$store.commit('SET_TOKEN', response.data.token)
          this.$store.commit('SET_AUTHENTICATED')
          this.$store.commit('SET_USER', response.data.user)
          this.hideAuthentication()
        })
        .catch(() => {
          this.$store.commit('REVOKE_TOKEN')
        })
    },
    hideAuthentication () {
      this.authenticated = true
    },
    validateToken () {
      const token = window.localStorage.getItem('token_pontveer')
      if (token) {
        this.$store.commit('SET_TOKEN', token)

        axios.get(`${process.env.VUE_APP_API_URL}/auth/me`)
          .then(response => {
            this.$store.commit('SET_AUTHENTICATED')
            this.$store.commit('SET_USER', response.data)
            this.hideAuthentication()
          })
          .catch(() => {
            this.$store.commit('REVOKE_TOKEN')
            this.getToken()
          })
      } else {
        this.$store.commit('REVOKE_TOKEN')
        this.getToken()
      }
    }
  },
  created () {
    this.validateToken()
  }
}
</script>

<style lang="scss" scoped>
.auth {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100vh;
  background: #23a6ee;
}
</style>
